import { Button, Paper, Box, Grid, Typography } from '@material-ui/core';
import { useState } from 'react';
import UploadJson, { downloadJSONFile } from '../components/UploadJson';
import PopupLandingBuilder from './PopupLandingBuilder';
import { options } from './renders';

function LandingTemplate({
  isRTL,
  theme,
  template,
  setTemplate,
  company,
  words,
}) {
  const [open, setOpen]: any = useState(false);
  return (
    <Paper elevation={4} style={{ marginBottom: 20 }}>
      <Box style={{ padding: 20 }}>
        <Typography variant="h6">Landing Template</Typography>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <UploadJson setValue={setTemplate}></UploadJson>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="outlined"
              onClick={() => downloadJSONFile(template, 'landingTemplate')}
              fullWidth
            >
              Download
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => setOpen(true)}
            >
              Edit
            </Button>
          </Grid>
        </Grid>
      </Box>

      <PopupLandingBuilder
        landing
        options={options}
        open={open}
        onClose={() => setOpen(false)}
        template={template}
        setTemplate={setTemplate}
        isRTL={isRTL}
        theme={theme}
        title="Edit"
        company={company}
        words={words}
      ></PopupLandingBuilder>
    </Paper>
  );
}

export default LandingTemplate;
